/**
 * Helpers tier physician — client-safe (pas de deps server-only).
 *
 * Doit rester sans import de `physicians.ts` (qui pull `physicians-scraped` +
 * `physicians-medma` marqués `server-only`). Utilisable depuis client + server.
 */

export type PhysicianTier = "gold" | "premium" | "free" | "unclaimed";

/** Gate booking en ligne : tout médecin AYANT REVENDIQUÉ sa fiche (free / gold /
 *  premium) a accès au flow /rdv/[slug]. La fiche + les RDV en ligne sont GRATUITS
 *  (offre d'acquisition) ; seul le boost de visibilité (top 3 ville) est payant.
 *  Seul `unclaimed` (scrap jamais revendiqué, personne pour confirmer les RDV)
 *  reste en modale UnclaimedCallButton "ce médecin n'est pas inscrit, appelez ce
 *  numéro" + invite patient à demander l'inscription au médecin.
 *  Cf. décision produit 2026-05-18 (RDV en ligne ouverts au tier=free). */
export function canBookOnline(tier: PhysicianTier): boolean {
  return tier !== "unclaimed";
}

/**
 * Affichage RÉEL du RDV en ligne sur une fiche/carte.
 *
 * Deux conditions cumulatives (décision produit 2026-05-22) :
 *   1. Gate tier : `canBookOnline(tier)` — la fiche est revendiquée (pas unclaimed)
 *   2. Toggle médecin : `onlineBookingEnabled` activé explicitement dans l'espace pro
 *
 * Sans le toggle, une fiche VERIFIED (ex CROMC vérifiée en masse) affichait le
 * bouton RDV alors que le médecin n'a configuré NI motifs NI créneaux → RDV
 * fantôme. Désormais le médecin doit activer l'option pour exposer le booking ;
 * sinon la fiche reste en mode "Appeler".
 *
 * `onlineBookingEnabled` peut être undefined sur le catalogue statique périmé →
 * traité comme false (fail-safe : pas de RDV fantôme).
 */
export function isOnlineBookingActive(p: {
  tier: PhysicianTier;
  onlineBookingEnabled?: boolean;
}): boolean {
  return canBookOnline(p.tier) && p.onlineBookingEnabled === true;
}
